<template>
  <div class="main_content mt-2" style="border-radius: 10px; border: 1px solid gainsboro" ref="formContainer">
    <h2>Calendly widget settings:</h2>
    <hr>
    <label>Add widget</label>
    <div class="page">
      <div class="page__toggle">
        <textarea v-model="calendlyWidgetCode" ref="widgetTextarea" class="widget-textarea" id="widgetTextarea" rows="4" placeholder="Enter Calendly widget code here"></textarea>
        <hr>
        <div class="row btn_row button_center">
          <a type="button" value="" class="btn btn-default save_btn" @click="showHideAlert"> Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TogglerSwitch from '../toggle_switch.vue'
  import axios from 'axios';

  export default {
    name: 'app',
    components: {
      TogglerSwitch
    },
    data() {
      return {
        active: 'false',
        status: 'false',
        calendlyWidgetCode: '',
      };
    },
    created: function () {
     this.getCalendlyWidget();

    },

    methods: {
      async getCalendlyWidget(){
           const permission = {
      headers: {
        'X-Permission': 'calendly_widget_list' 
      }
    }; 
        axios.get('/admin/settings/show-calendly-widget',permission)
          .then((response) => {
            if (response.data.calendly_record && response.data.calendly_record.calendly_widget) {
              this.calendlyWidgetCode = response.data.calendly_record.calendly_widget;
            }
          })
          .catch((error) => {
            console.error('Error fetching Calendly widget:', error);
          });
      },
  async showHideAlert() {
    let loader = this.$loading.show({
      loader: 'dots',
      container: this.fullPage ? null : this.$refs.formContainer,
    });

    if ($("#togBtn").prop('checked') == true) {
      this.active = 'true';
    } else {
      this.active = 'false';
    }
    const permission = {
      headers: {
        'X-Permission': 'calendly_widget_list' 
      }
    }; 
    try {
      const response = await axios.post('/admin/settings/add-calendly-widget',{
        calendly_widget: this.$refs.widgetTextarea.value,
      },permission);

      // Send successful message
      this.$toast.success('Setting Updated Successfully!');

      loader.hide();
    } catch (error) {
      // Send error message
      this.$toast.error('Setting not saved, an error occurred!');
      loader.hide();
    }
  }
}

  }
</script>
<style scoped>
  .main_content {
    background-color: white;
    padding: 20px;
    /* margin-top: 30px; */
    border-radius: 10px;
  }

  .tooltip_icon {
    color: #2569A3;
    background-color: white;
    border-color: white;
    padding: 0px 2px
  }

  .btn_row {
    padding-left: 10px;
    margin-top: 20px;
    margin-bottom: 15px;
  }

  .save_btn {
    float: right;
    color: white !important;
  }


  .toggle {
    --uiToggleSize: var(--toggleSize, 20px);
    --uiToggleIndent: var(--toggleIndent, .4em);
    --uiToggleBorderWidth: var(--toggleBorderWidth, 2px);
    --uiToggleColor: var(--toggleColor, #000);
    --uiToggleDisabledColor: var(--toggleDisabledColor, #868e96);
    --uiToggleBgColor: var(--toggleBgColor, #fff);
    --uiToggleArrowWidth: var(--toggleArrowWidth, 2px);
    --uiToggleArrowColor: var(--toggleArrowColor, #fff);

    display: inline-block;
    position: relative;
  }

  .toggle__input {
    position: absolute;
    left: -99999px;
  }

  .toggle__label {
    display: inline-flex;
    cursor: pointer;
    min-height: var(--uiToggleSize);
    padding-left: calc(var(--uiToggleSize) + var(--uiToggleIndent));
  }

  .toggle__label:before,
  .toggle__label:after {
    content: "";
    box-sizing: border-box;
    width: 1em;
    height: 1em;
    font-size: var(--uiToggleSize);

    position: absolute;
    left: 0;
    top: 0;
  }

  .toggle__label:before {
    border: var(--uiToggleBorderWidth) solid var(--uiToggleColor);
    z-index: 2;
  }

  .toggle__input:disabled~.toggle__label:before {
    border-color: var(--uiToggleDisabledColor);
  }

  .toggle__input:focus~.toggle__label:before {
    box-shadow: 0 0 0 2px var(--uiToggleBgColor), 0 0 0px 4px var(--uiToggleColor);
  }

  .toggle__input:not(:disabled):checked:focus~.toggle__label:after {
    box-shadow: 0 0 0 2px var(--uiToggleBgColor), 0 0 0px 4px var(--uiToggleColor);
  }

  .toggle__input:not(:disabled)~.toggle__label:after {
    background-color: var(--uiToggleColor);
    opacity: 0;
  }

  .toggle__input:not(:disabled):checked~.toggle__label:after {
    opacity: 1;
  }

  .toggle__text {
    margin-top: auto;
    margin-bottom: auto;
  }

  /*
The arrow size and position depends from sizes of square because I needed an arrow correct positioning from the top left corner of the element toggle
*/

  .toggle__text:before {
    content: "";
    box-sizing: border-box;
    width: 0;
    height: 0;
    font-size: var(--uiToggleSize);

    border-left-width: 0;
    border-bottom-width: 0;
    border-left-style: solid;
    border-bottom-style: solid;
    border-color: var(--uiToggleArrowColor);

    position: absolute;
    top: .5428em;
    left: .2em;
    z-index: 3;

    transform-origin: left top;
    transform: rotate(-40deg) skew(10deg);
  }

  .toggle__input:not(:disabled):checked~.toggle__label .toggle__text:before {
    width: .5em;
    height: .25em;
    border-left-width: var(--uiToggleArrowWidth);
    border-bottom-width: var(--uiToggleArrowWidth);
    will-change: width, height;
    transition: width .1s ease-out .2s, height .2s ease-out;
  }

  /*
=====
LEVEL 2. PRESENTATION STYLES
=====
*/

  /* 
The demo skin
*/

  .toggle__label:before,
  .toggle__label:after {
    border-radius: 1px;
  }

  /* 
The animation of switching states
*/

  .toggle__input:not(:disabled)~.toggle__label:before,
  .toggle__input:not(:disabled)~.toggle__label:after {
    opacity: 1;
    transform-origin: center center;
    will-change: transform;
    transition: transform .2s ease-out;
  }

  .toggle__input:not(:disabled)~.toggle__label:before {
    transform: rotateY(0deg);
    transition-delay: .2s;
  }

  .toggle__input:not(:disabled)~.toggle__label:after {
    transform: rotateY(90deg);
  }

  .toggle__input:not(:disabled):checked~.toggle__label:before {
    transform: rotateY(-90deg);
    transition-delay: 0s;
  }

  .toggle__input:not(:disabled):checked~.toggle__label:after {
    transform: rotateY(0deg);
    transition-delay: .2s;
  }

  .toggle__text:before {
    opacity: 0;
  }

  .toggle__input:not(:disabled):checked~.toggle__label .toggle__text:before {
    opacity: 1;
    transition: opacity .1s ease-out .3s, width .1s ease-out .5s, height .2s ease-out .3s;
  }

  /*
=====
LEVEL 3. SETTINGS
=====
*/

  .toggle {
    --toggleColor: #48a6a6;
    ;
    --toggleBgColor: #48a6a6;
    ;
    --toggleSize: 25px;
  }

  /*
=====
DEMO
=====
*/

  body {
    min-height: 100vh;
    margin: 0;
    display: flex;
    flex-direction: column;
    /* font-family: Mulish, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Open Sans, Ubuntu, Fira Sans, Helvetica Neue, sans-serif;   */
    font-family: 'Mulish', sans-serif;
    background-color: #9b59b6;
  }

  .page {
    margin: auto;
    padding-left: 10px;
    padding-right: 10px;
    order: 1;
  }

  .page__toggle {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
  }

  .page__toggle:nth-child(n+2) {
    margin-top: 50px;
  }


  /*
=====
LinkedIn
=====
*/

  .linkedin {
    width: 100%;
    background-color: #fff;
    text-align: center;

    position: absolute;
    top: 0;
    left: 0;
  }

  .linkedin__container {
    max-width: 1000px;
    padding: 10px;
    margin-left: auto;
    margin-right: auto;
  }

  .linkedin__text {
    margin-top: 0;
    margin-bottom: 0;
  }

  .linkedin__link {
    color: #ff5c5c;
  }
  .message.card.card-body{
    position: absolute !important;
  }
  .widget-textarea {
    width: 100%;
    resize: vertical;
    border: 1px solid #9A9AB0;
    font-weight: normal;
    padding-left: 5px;
    padding-top: 5px;
  }
  .widget-textarea::placeholder {
    color: #808080;
  }
   @media (min-width: 320px) and (max-width:680px){
    .button_center{
      justify-content: space-around !important;
    }
   }
</style>